// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"26f3746a","154":"bad77c94","770":"0fa0d6cf","820":"da32fad3","827":"700a5996","949":"0f791d44","985":"85fa1c99"}[chunkId] + ".css";
};